// Packages Reducer

import { initializeState } from '../../../utilities/storageUtils';
import packagesActionTypes from './packages.types';

const INITIAL_STATE = {
  selectedPackages: [],
  packageAvailabilityList: [],
  cabanasAvailabilityList: [],
  isLoading: false,
  requestFailed: false,
  errorMessage: '',
  status: '',
  planPackages: []
};

const packagesReducer = (state, action) => {
  state = initializeState(state, INITIAL_STATE);

  switch (action.type) {
    case packagesActionTypes.SET_PACKAGES_PLAN_INFO_SUCCESS:
      return {
        ...state,
        planPackages: action.planPackages
      };
    // Get Package Availability SUCCESS
    case packagesActionTypes.GET_PACKAGES_AVAILABILITY_INFO_SUCCESS:
      return {
        ...state,
        packageAvailabilityList: action.packageAvailabilityList,
        requestFailed: false,
        isLoading: false,
        errorMessage: ''
      };
    // Get Package Availability LOADING
    case packagesActionTypes.GET_PACKAGES_AVAILABILITY_INFO_LOADING:
      return {
        ...state,
        isLoading: action.isLoading
      };
    // Get Package Availability FAIL
    case packagesActionTypes.GET_PACKAGES_AVAILABILITY_INFO_ERROR:
      return {
        ...state,
        packageAvailabilityList: action.packageAvailabilityList,
        requestFailed: action.requestFailed,
        isLoading: false,
        errorMessage: action.errorMessage
      };
    case packagesActionTypes.UPSERT_PACKAGES:
      return {
        ...state,
        selectedPackages: action.selectedPackages
      };
    case packagesActionTypes.DELETE_PACKAGES:
      return {
        ...state,
        selectedPackages: action.selectedPackages
      };
    case packagesActionTypes.CLEAR_PACKAGES_SELECTED:
      return {
        ...state,
        selectedPackages: action.selectedPackages
      };

    case packagesActionTypes.GET_PACKAGES_CABANAS_AVAILABILITY_SUCCESS:
      return {
        ...state,
        cabanasAvailabilityList: action.cabanasAvailabilityList,
        isLoading: false
      };
    // Get Package Availability LOADING
    case packagesActionTypes.GET_PACKAGES_CABANAS_AVAILABILITY_LOADING:
      return {
        ...state,
        isLoading: action.isLoading
      };
    // Get Package Availability FAIL
    case packagesActionTypes.GET_PACKAGES_CABANAS_AVAILABILITY_ERROR:
      return {
        ...state,
        cabanasAvailabilityList: action.cabanasAvailabilityList,
        isLoading: false
      };
    case packagesActionTypes.CLEAR_PACKAGES_BY_CODES:
      return {
        ...state,
        selectedPackages: action.selectedPackages
      };
    case packagesActionTypes.CLEAR_PACKAGES_PLAN:
      return {
        ...state,
        selectedPackages: action.selectedPackages,
        planPackages: action.planPackages
      };

    default:
      return state;
  }
};

export default packagesReducer;
